export default __webpack_public_path__ + "assets/19dc3949dfbf871203d9991f5cd1bd05.svg";